import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { slugify } from '@surfline/web-common';
import { spotReportPath } from '@surfline/web-common/dist/paths/kbyg';
import spotProptype from '../../propTypes/spot';

const getClassName = active =>
  classNames({
    'sl-cam-list-link': true,
    'sl-cam-list-link--active': active,
  });

const CamListLink = ({
  spot,
  doTrackEvent,
  children,
  location,
  onMouseEnter,
  onMouseLeave,
  active,
}) => (
  <Link
    to={spotReportPath(slugify(spot.name), spot._id)}
    className={getClassName(active)}
    onClick={() =>
      doTrackEvent('Clicked Nearby Spot', {
        spotId: spot._id,
        spotName: spot.name,
        clickedLocation: location,
      })
    }
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    title={`${spot.name} Surf Report & Forecast`}
  >
    {children}
  </Link>
);

CamListLink.defaultProps = {
  doTrackEvent: () => null,
  onMouseEnter: null,
  onMouseLeave: null,
  active: false,
};

CamListLink.propTypes = {
  spot: spotProptype.isRequired,
  doTrackEvent: PropTypes.func,
  children: PropTypes.node.isRequired,
  location: PropTypes.string.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  active: PropTypes.bool,
};

export default CamListLink;
